import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import overlayFactory from "react-bootstrap-table2-overlay";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Card from "../../components/Cards/Card";
import { CustomSwitch } from "../../components/CustomControls/CustomSwitch";
import { PractitionerPicker } from "../../components/CustomControls/PractitionerPicker";
import { Save } from "../../components/Icons/Icons";
import { testNotifications } from "../../api/clinicalTrial";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  getModuleConfigs,
  getStakeholders,
  saveModuleConfigs,
  saveStakeholders,
} from "../../api/settings";
import { HandleApiError } from "../../components/Notifications/APIErrorHandler";
import { Spinner } from "../../components/Utils/Loaders";

export const NotificationsContainer = () => {
  const { t } = useTranslation();
  const [
    selectedPractitionersSiteManager,
    setSelectedPractitionersSiteManager,
  ] = useState([]);
  const defaultTestTablePractitionerData = {
    practitionerUserId: "",
    fullName: "",
    email: false,
    sms: false,
    whatsapp: false,
  };
  const [selectedPractitionerTest, setSelectedPractitionerTest] = useState([]);
  const [successAlertTitle, setSuccessAlertTitle] = useState(null);
  const [successAlertText, setSuccessAlertText] = useState(null);
  const [errorAlertText, setErrorAlertText] = useState(null);
  const [testTableData, setTestTableData] = useState([
    defaultTestTablePractitionerData,
  ]);
  const [sendingTestEmail, setSendingTestEmail] = useState(false);

  const [modules, setModules] = useState([
    {
      id: 1,
      name: t("clinicalTrials.notifications.agendaOption"),
      email: true,
      whatsapp: false,
      sms: false,
    },
    {
      id: 2,
      name: t("clinicalTrials.notifications.protocolOption"),
      email: true,
      whatsapp: false,
      sms: false,
    },
    {
      id: 3,
      name: t("clinicalTrials.notifications.clinicalTrialOption"),
      email: true,
      whatsapp: false,
      sms: false,
    },
    {
      id: 4,
      name: t("clinicalTrials.notifications.regulatoryOption"),
      email: true,
      whatsapp: false,
      sms: false,
    },
  ]);

  useEffect(() => {
    const fetchPractitioners = async () => {
      try {
        const response = await getStakeholders();
        console.log(response);
        const mappedPractitioners = response.data.map((p) => ({
          ...p,
          name: p.name,
          fullNameUnique: `${p.name} (${p.email})`,
          userId: p.practitionerUserId,
          email: p.email,
        }));
        setSelectedPractitionersSiteManager(mappedPractitioners);
      } catch (err) {
        HandleApiError(err);
      }
    };

    fetchPractitioners();
  }, []);

  useEffect(() => {
    const fetchModules = async () => {
      try {
        const response = await getModuleConfigs();
        if (response?.data?.length > 0) {
          const mappedModules = response.data.map((m) => ({
            id: m.id,
            name: m.moduleName,
            email: m.emailEnabled,
            whatsapp: m.whatsAppEnabled,
            sms: m.smsEnabled,
          }));
          setModules(mappedModules);
        }
      } catch (err) {
        HandleApiError(err);
      }
    };

    fetchModules();
  }, []);

  const handleSwitchChange = (rowIndex, field, value) => {
    setModules((prevModules) =>
      prevModules.map((module, index) =>
        index === rowIndex ? { ...module, [field]: value } : module
      )
    );
  };

  const handlePractitionerSiteManagerSelect = (key, selectedList) => {
    if (!Array.isArray(selectedList)) return;

    setSelectedPractitionersSiteManager(selectedList);
  };

  const columnsTest = [
    {
      dataField: "fullName",
      text: t("clinicalTrials.notifications.testTableNameLabel"),
      formatter: (_, row) => (
        <PractitionerPicker
          selected={selectedPractitionerTest}
          onChange={handlePractitionerTestSelect}
          id="practitionerSelect"
          multiple={false}
        />
      ),
    },
    {
      dataField: "email",
      text: t("clinicalTrials.notifications.testTableEmailLabel"),
      formatter: (_, row) => (
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => {
            handleSendTestEmailNotification();
          }}
        >
          {t("settings.settings.test")}
        </button>
      ),
    },
    {
      dataField: "sms",
      text: t("clinicalTrials.notifications.testTableSMSLabel"),
      formatter: (_, row) => (
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => {}}
          disabled
        >
          {t("settings.settings.test")}
        </button>
      ),
    },
    {
      dataField: "whatsapp",
      text: t("clinicalTrials.notifications.testTableWhatsAppLabel"),
      formatter: (_, row) => (
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => {}}
          disabled
        >
          {t("settings.settings.test")}
        </button>
      ),
    },
  ];

  const columns = [
    {
      dataField: "name",
      text: t("security.roles.name"),
      headerStyle: { width: "250px" },
    },

    {
      dataField: "email",
      text: t("settings.settings.email"),
      isDummyField: true,
      headerClasses: "header-actions",
      classes: "row-actions",
      formatter: function (_cell, row, rowIndex) {
        return (
          <div style={{ all: "initial", display: "inline-block" }}>
            <CustomSwitch
              name="email"
              value={row.email}
              onChange={(_, val) => handleSwitchChange(rowIndex, "email", val)}
            />
          </div>
        );
      },
    },
    {
      dataField: "whatsapp",
      text: t("settings.settings.whatsapp"),
      isDummyField: true,
      headerClasses: "header-actions",
      classes: "row-actions",
      formatter: function (_cell, row, rowIndex) {
        return (
          <div style={{ all: "initial", display: "inline-block" }}>
            <CustomSwitch
              name="whatsapp"
              value={row.whatsapp}
              disabled={true}
              onChange={(_, val) =>
                handleSwitchChange(rowIndex, "whatsapp", val)
              }
            />
          </div>
        );
      },
    },
    {
      dataField: "sms",
      text: t("settings.settings.SMS"),
      isDummyField: true,
      headerClasses: "header-actions",
      classes: "row-actions",
      formatter: function (_cell, row, rowIndex) {
        return (
          <div style={{ all: "initial", display: "inline-block" }}>
            <CustomSwitch
              name="sms"
              value={row.sms}
              disabled={true}
              onChange={(_, val) => handleSwitchChange(rowIndex, "sms", val)}
            />
          </div>
        );
      },
    },
  ];

  const handleSaveNotifications = async () => {
    try {
      const payload = selectedPractitionersSiteManager.map((p) => ({
        practitionerUserId: p.practitionerUserId || p.userId,
        name: p.name || p.fullName || p.fullNameUnique,
        email: p.email ?? p.userName,
      }));

      const stakeholdersResponse = await saveStakeholders(payload);

      const mappedModules = modules.map((m) => ({
        id: m.id,
        module: m.name,
        email: m.email,
        whatsapp: m.whatsapp,
        sms: m.sms,
      }));

      const modulesResponse = await saveModuleConfigs(mappedModules);

      if (
        stakeholdersResponse?.status === 200 &&
        modulesResponse?.status === 200
      ) {
        setSuccessAlertTitle(
          t("clinicalTrials.notifications.configSaveSuccessTitle")
        );
        setSuccessAlertText(
          t("clinicalTrials.notifications.configSaveSuccessText")
        );
      } else {
        setErrorAlertText(
          t("clinicalTrials.notifications.configSaveErrorText")
        );
      }
    } catch (err) {
      setErrorAlertText(t("clinicalTrials.notifications.configSaveErrorText"));
    }
  };

  const handlePractitionerTestSelect = (key, selectedList) => {
    if (!selectedList) {
      setSelectedPractitionerTest([]);
      setTestTableData([defaultTestTablePractitionerData]);
      return;
    }

    // Asegurar que selectedList sea un array
    const practitionersArray = Array.isArray(selectedList) 
      ? selectedList 
      : [selectedList];

    setSelectedPractitionerTest(practitionersArray);
    setTestTableData(
      practitionersArray.map((practitioner) => ({
        ...practitioner,
        practitionerUserId: practitioner.userId,
        fullName: practitioner.fullName,
        email: false,
        sms: false,
        whatsapp: false,
      }))
    );
  };

  const handleSendTestEmailNotification = async () => {
    if (!selectedPractitionerTest || selectedPractitionerTest.length === 0) {
      return;
    }

    const [selected] = selectedPractitionerTest;

    const payload = {
      email: selected.userName,
      userId: selected.userId,
      date: "2025-07-02",
      practitionerName: selected.fullName,
      location: "Consultorio 5",
    };

    try {
      setSendingTestEmail(true);
      const response = await testNotifications(payload);

      if (response?.data === true) {
        setSuccessAlertTitle(
          t("clinicalTrials.notifications.testEmailSuccessTitle")
        );
        setSuccessAlertText(
          `${t("clinicalTrials.notifications.testEmailSuccessText")} ${selected.fullName}`
        );
      } else {
        setErrorAlertText(t("clinicalTrials.notifications.testEmailErrorText"));
      }
    } catch (err) {
      setErrorAlertText(t("clinicalTrials.notifications.testEmailErrorText"));
    } finally {
      setSendingTestEmail(false);
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: "12px",
          marginBottom: "12px",
          marginTop: "12px",
        }}
      >
        <button
          type="button"
          className="btn btn-success"
          onClick={() => handleSaveNotifications()}
        >
          <Save />
          {t("clinicalTrials.notifications.save")}
        </button>
      </div>
      <Card
        content={
          <>
            <Row>
              <Col md={12}>
                <div className="header" style={{ padding: 0 }}>
                  <h4 className="title">
                    {t("clinicalTrials.notifications.moduleSettings")}
                  </h4>
                  <hr />
                </div>
              </Col>
            </Row>
            <BootstrapTable
              bordered={false}
              hover
              remote
              keyField="id"
              classes="table-spaced table-spaced-small"
              wrapperClasses="table-responsive"
              data={modules}
              columns={columns}
              noDataIndication={() => <>{t("commons.noData")}</>}
              overlay={overlayFactory({ spinner: true })}
            />
          </>
        }
      />
      <Card
        content={
          <>
            <Row>
              <Col md={12}>
                <div className="header" style={{ padding: 0 }}>
                  <h4 className="title">
                    {t("clinicalTrials.notifications.siteManager")}
                  </h4>
                  <hr />
                </div>
              </Col>
            </Row>
            <PractitionerPicker
              selected={selectedPractitionersSiteManager}
              onChange={handlePractitionerSiteManagerSelect}
              multiple={true}
              id="multiPractitionerPicker"
              labelKey="name"
            />
          </>
        }
      />
      <Card
        content={
          <>
            <Row>
              <Col md={12}>
                <div className="header" style={{ padding: 0 }}>
                  <h4 className="title">
                    {t("clinicalTrials.notifications.testing")}
                  </h4>
                  <hr />
                </div>
              </Col>
            </Row>
            {!!sendingTestEmail && <Spinner />}
            {!sendingTestEmail && (
              <BootstrapTable
                data={testTableData}
                keyField="practitionerUserId"
                columns={columnsTest}
                bordered={false}
                classes="table-sm table-striped"
              />
            )}
          </>
        }
      />

      {successAlertText && (
        <SweetAlert
          success
          title={successAlertTitle || "Operación exitosa"}
          onConfirm={() => setSuccessAlertText(null)}
          confirmBtnBsStyle="success"
          confirmBtnText="OK"
        >
          {successAlertText}
        </SweetAlert>
      )}

      {errorAlertText && (
        <SweetAlert
          danger
          title="Error"
          onConfirm={() => setErrorAlertText(null)}
          confirmBtnBsStyle="danger"
          confirmBtnText="OK"
        >
          {errorAlertText}
        </SweetAlert>
      )}
    </>
  );
};
